export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "new_logbook": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Logbook"])},
        "training_standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Training standard"])},
        "training_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Training program"])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sorry, no matches found"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cannot save: see error messages above"])}
      },
      "fr": {
        "new_logbook": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau journal de bord"])},
        "training_standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Norme de formation"])},
        "training_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programme de formation"])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])},
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désolé, aucune correspondance n'a été trouvée"])},
        "error_warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de sauver: voyez les messages d'erreur ci-dessus"])}
      }
    }
  })
}